import { getGIA as a } from "./index26.js";
import { getGrossFacadeArea as e } from "./index28.js";
const g = (o) => {
  const r = e(o), t = a(o);
  return r / t;
};
export {
  g as getWallToFloorRatio
};
//# sourceMappingURL=index60.js.map
